import { IsNotEmpty, IsOneOfTheseCaseInsensitive, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { Expose, Transform } from 'class-transformer'
import { IDateService } from '@master/services/IDateService'
import { container, cid } from 'inversify-props'
import { HierarchySetupDTO } from '@core/pages/hierarchy-setup/api'
import { parseToCorrectString } from '@core/services/csv/CSVTransformer'

const dateService = container.get<IDateService>(cid.IDateService)

export class HierarchySetupCsvModel extends CSVModelInterface implements HierarchySetupDTO {
  filename = 'HierarchySetupTemplate'

  @Expose()
  private 'Oid' = 'Existing Compensation Record Unique Identifying Number (To add a new record leave this field empty)'

  get oid () {
    return this.Oid
  }

  @Expose()
  private 'AWG Rep Code' = 'AWG001'

  get pfpfaRepCode () {
    return this['AWG Rep Code']
  }

  @Expose()
  private 'Scheme' = 'TA'

  get scheme () {
    return this.Scheme
  }

  @Expose()
  private 'Schedule Name' = 'New'

  get scheduleName () {
    return this['Schedule Name']
  }

  @Expose()
  private 'Name (Name Reflected on MAS System)' = 'John Doe'

  get name () {
    return this['Name (Name Reflected on MAS System)']
  }

  @Expose()
  private 'Reporting Agent (RA) Code 1' = 'AWG002'

  get reportingAgentRaCode1 () {
    return this['Reporting Agent (RA) Code 1']
  }

  @Expose()
  private 'Reporting Agent (RA) Name 1' = 'Jane Doe'

  get reportingAgentRaName1 () {
    return this['Reporting Agent (RA) Name 1']
  }

  @Expose()
  private 'Designation' = 'Director'

  get designation () {
    return this.Designation
  }

  @Expose()
  private 'Reporting Agent (RA) Code 2' = 'AWG003'

  get reportingAgentRaCode2 () {
    return this['Reporting Agent (RA) Code 2']
  }

  @Expose()
  private 'Reporting Agent (RA) Name 2' = 'Bob Doe'

  get reportingAgentRaName2 () {
    return this['Reporting Agent (RA) Name 2']
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfTheseCaseInsensitive(['Active', 'Inactive'])
  @Transform(({ value }) => parseToCorrectString(value, ['Active', 'Inactive']))
  private 'Status' = 'Active/Inactive'

  get status () {
    return this.Status
  }

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Start Date' = '31/12/2020'

  get startDate () {
    return dateService.toUnixMilliseconds(this['Start Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'End Date' = '31/12/2020'

  get endDate () {
    return dateService.toUnixMilliseconds(this['End Date'], 'DD/MM/YYYY')
  }

  @Expose()
  private 'Tier 1 RP' = 50

  get tier1SinglifeRp () {
    return this['Tier 1 RP']
  }

  @Expose()
  private 'Tier 1 SP' = 50

  get tier1SinglifeSp () {
    return this['Tier 1 SP']
  }

  get tier1Others () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Tier 1 GI' = 50

  get tier1Gi () {
    return this['Tier 1 GI']
  }

  get tier1Referrals () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Tier 2 RP' = 50

  get tier2SinglifeRp () {
    return this['Tier 2 RP']
  }

  @Expose()
  private 'Tier 2 SP' = 50

  get tier2SinglifeSp () {
    return this['Tier 2 SP']
  }

  get tier2Others () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Tier 2 GI' = 50

  get tier2Gi () {
    return this['Tier 2 GI']
  }

  get tier2Referrals () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Tier 3 RP' = 50

  get tier3SinglifeRp () {
    return this['Tier 3 RP']
  }

  @Expose()
  private 'Tier 3 SP' = 50

  get tier3SinglifeSp () {
    return this['Tier 3 SP']
  }

  get tier3Others () {
    return 0 // AWG do not have this
  }

  get tier3Gi () {
    return 0 // AWG do not have this
  }

  get tier3Referrals () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Performance Bonus RP' = 50

  get performanceBonusSinglifeRp () {
    return this['Performance Bonus RP']
  }

  get performanceBonusSinglifeSp () {
    return 0 // AWG do not have this
  }

  get performanceBonusOthers () {
    return 0 // AWG do not have this
  }

  get performanceBonusgi () {
    return 0 // AWG do not have this
  }

  get performanceBonusReferrals () {
    return 0 // AWG do not have this
  }

  get serviceChargeSinglifeRp () {
    return 0 // AWG do not have this
  }

  get serviceChargeSinglifeSp () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Company\'s Banding ALl Ex GI' = 50

  get serviceChargeOthers () {
    return this['Company\'s Banding ALl Ex GI']
  }

  @Expose()
  private 'Company\'s Banding GI' = 50

  get serviceChargeGi () {
    return this['Company\'s Banding GI']
  }

  get serviceChargeReferrals () {
    return 0 // AWG do not have this
  }

  @Expose()
  private 'Profit Sharing RP' = 50

  get profitSharingRp () {
    return this['Profit Sharing RP']
  }
}
